import { render, staticRenderFns } from "./creatBargainMore.vue?vue&type=template&id=53f1b979&scoped=true"
import script from "./creatBargainMore.vue?vue&type=script&lang=js"
export * from "./creatBargainMore.vue?vue&type=script&lang=js"
import style0 from "./creatBargainMore.vue?vue&type=style&index=0&id=53f1b979&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f1b979",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f1b979')) {
      api.createRecord('53f1b979', component.options)
    } else {
      api.reload('53f1b979', component.options)
    }
    module.hot.accept("./creatBargainMore.vue?vue&type=template&id=53f1b979&scoped=true", function () {
      api.rerender('53f1b979', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/bargain/bargainGoods/creatBargainMore.vue"
export default component.exports